

import React, { useEffect, useState } from 'react';
import { useSearchParams, useParams, useLocation, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchClientQuotationList } from '../redux/clientQuotationReducer';
import { Card, Container, Row, Col, ListGroup, Tab, Nav, Button, Accordion, Table } from 'react-bootstrap';
import './ClientQuotation.css';
import { auth, firestore as db } from "../config/Config";
import { fetchLinkQuotation } from '../redux/clientLinkReducer';
import { Triangle } from 'react-loader-spinner';
import { PDFDownloadLink } from '@react-pdf/renderer';
import ClientPDF from './ClientPDF';
import { Text } from 'lucide-react';


export default function ClientQuotation() {

  // const dispatch = useDispatch();
  // const { clientIDD } = useParams();
  // const [searchParams, setSearchParams] = useSearchParams();
  // const firstID = searchParams.get("cqifds");
  // const secondID = searchParams.get("cqid");

  // useEffect(()=>{
  //   const linkData1 = {
  //     Id:secondID,
  //     Id2:firstID,
  //   }
  //   dispatch(fetchLinkQuotation(linkData1));
  // }, []);
  // const { linkData, linkLoader, linkError} = useSelector((state)=>state.linkQuote);

  // console.log('adasd',linkData);
    const userDetails = JSON.parse(localStorage.getItem('userDetails'));

  const [quotation, setQuotation] = useState(null);
  const [userDetails1, setUserDetails1] = useState(userDetails);
  console.log("quotation", quotation);

  const [error, setError] = useState(null);
  const { clientId, quotationId } = useParams();

  const [groupedData, setGroupedData] = useState({});
  console.log('groupedData', groupedData);


  useEffect(() => {
    const fetchQuotation = async () => {
      try {
        const response = await fetch(`https://us-central1-fabdiz-quote.cloudfunctions.net/api/project/${clientId}/quotations/${quotationId}`);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setQuotation(data);
        console.log("data", data);
      } catch (error) {
        console.error("Error fetching quotation:", error);
        setError(error.message);
      }
    };

    fetchQuotation();
  }, [clientId, quotationId]);


  useEffect(() => {
    const tempGrouped = {};

    quotation?.quotationData.forEach((item) => {
      item.title.forEach((item2) => {
        const name = item2.name;
        console.log(name);

        if (!tempGrouped[name]) {
          tempGrouped[name] = [];
        }
        tempGrouped[name].push(item2);
      });
    });

    setGroupedData(tempGrouped);
    console.log(tempGrouped);
  }, [quotation]);


  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!quotation) {
    return <center><Triangle
      height="120"
      width="120"
      color="#ff5100"
      ariaLabel="triangle-loading"
      radius="1"
      wrapperStyle={{ position: "absolute", top: "50%", left: "50%", }}
      wrapperClass=""
      visible={true}
    /> </center>;
  }

  const tdStyle = {
  border: "1px solid #3f3d3d",
  padding: "14px",
  fontSize: "14px",
  verticalAlign: "middle",
  color:'black' 
};




  return (
    <Container  >
      <Row>
        <Col sm={1}></Col>
        <Col sm={11}>
          <>
            <Row className='py-5'>
              <Col>
                <img style={{ width: '10rem' }} src={require('../assests/PDFlogo.png')} className='img-Logo' />
                <p className=" text-muted fw-semibold">You are about to experience creativity and commitment at its best .</p>
              </Col>
              <hr />
            </Row>


            <Row className=''>
              <Col>
                <h5 >Hi {quotation.clientDetails.cname} & Family,</h5>
                <p >Here is the quote that you requested. Please review and reach out to us, for any questions</p>
              </Col>
            </Row>

            <Col>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "8px",
                  marginTop: "20px",
                  marginBottom: "20px",
                }}
              >
                <div
                  style={{
                    borderBottom: "3px solid #ff6619",
                    width: "10%",
                    marginBottom: "6px",
                    marginRight: "12px",
                    marginLeft: "12px",
                  }}
                />
                <div>
                  <p style={{ margin: 0, fontWeight: "bold" }}>Project Details</p>
                </div>
              </div>
            </Col>
            <Col>
              <div style={{ position: "relative", width: "100%", marginBottom: "15px" }}>
                {/* Shadow */}
                <div
                  style={{
                    position: "absolute",
                    top: "4px",
                    left: "11px",
                    width: "96%",
                    backgroundColor: "#f0f0f0",
                    borderRadius: "10px",
                    height: "100%",
                    zIndex: 0,
                  }}
                />

                {/* Main Card */}
                <div
                  style={{
                    position: "relative",
                    width: "96%",
                    backgroundColor: "#ffffff",
                    marginLeft: "7px",
                    borderRadius: "5px",
                    padding: "10px",
                    display: "flex",
                    flexDirection: "row",
                    // justifyContent: "space-evenly",
                    alignItems: "center",
                    flexWrap: "wrap",
                    zIndex: 1, // keep above shadow
                    boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
                  }}
                >
                  {/* Block 1 */}
                  <div style={{ width: "25%", padding: "7px" }}>
                    <p style={{ marginBottom: "5px", fontSize: "12px", color: "#666" }}>
                      DESIGN CONSULTANT
                    </p>
                    <p style={{ fontSize: "12px", color: "#000", fontWeight: "bold" }}>
                      {quotation.clientDetails.createdBy}
                    </p>
                  </div>

                  {/* Block 2 */}
                  <div style={{ width: "25%", padding: "7px" }}>
                    <p style={{ marginBottom: "5px", fontSize: "12px", color: "#666" }}>
                      CUSTOMER SUPPORT
                    </p>
                    <p style={{ fontSize: "12px", color: "#000", fontWeight: "bold" }}>
                      9606459716
                    </p>
                  </div>

                  {/* Block 3 */}
                  <div style={{ width: "25%", padding: "7px" }}>
                    <p style={{ marginBottom: "5px", fontSize: "12px", color: "#666" }}>
                      QUOTE VERSION
                    </p>
                    <p style={{ fontSize: "12px", color: "#000", fontWeight: "bold" }}>
                      {quotation.quotationName}
                    </p>
                  </div>

                  {/* Block 4 */}
                  <div style={{ width: "10%", padding: "7px" }}>
                    <p style={{ marginBottom: "5px", fontSize: "12px", color: "#666" }}>
                      DATE
                    </p>
                    <p style={{ fontSize: "12px", color: "#000", fontWeight: "bold" }}>
                      {quotation.quotationDate}
                    </p>
                  </div>

                  {/* Block 5 */}
                  <div style={{ width: "25%", padding: "7px" }}>
                    <p style={{ marginBottom: "5px", fontSize: "12px", color: "#666" }}>
                      PROPERTY NAME
                    </p>
                    <p style={{ fontSize: "12px", color: "#000", fontWeight: "bold" }}>
                      {quotation.clientDetails.pname}
                    </p>
                  </div>

                  {/* Block 6 */}
                  <div style={{ width: "25%", padding: "7px" }}>
                    <p style={{ marginBottom: "5px", fontSize: "12px", color: "#666" }}>
                      CONFIGURATION
                    </p>
                    <p style={{ fontSize: "12px", color: "#000", fontWeight: "bold" }}>
                      {quotation.clientDetails.configuration}
                    </p>
                  </div>

                  {/* Block 7 */}
                  <div style={{ width: "25%", padding: "7px" }}>
                    <p style={{ marginBottom: "5px", fontSize: "12px", color: "#666" }}>
                      NUMBER
                    </p>
                    <p style={{ fontSize: "12px", color: "#000", fontWeight: "bold" }}>
                      {quotation.clientDetails.cphone}
                    </p>
                  </div>

                  {/* Block 8 */}
                  <div style={{ width: "25%", padding: "7px" }}>
                    <p style={{ marginBottom: "5px", fontSize: "12px", color: "#666" }}>
                      EMAIL
                    </p>
                    <p style={{ fontSize: "12px", color: "#000", fontWeight: "bold" }}>
                      {quotation.clientDetails.cemail}
                    </p>
                  </div>

                  {/* Block 9 */}
                  <div style={{ width: "auto", padding: "7px" }}>
                    <p style={{ marginBottom: "5px", fontSize: "12px", color: "#666" }}>
                      ADDRESS
                    </p>
                    <p style={{ fontSize: "12px", color: "#000", fontWeight: "bold" }}>
                      {quotation.clientDetails.city}
                    </p>
                  </div>
                </div>
              </div>
            </Col>

            <Col>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  gap: "20px",
                  padding: "20px",
                }}
              >
                {/* ROOM NAME */}
                <div style={{ position: "relative", width: "50%", marginTop: "15px" }}>
                  {/* Shadow */}
                  <div
                    style={{
                      position: "absolute",
                      top: "4px",
                      width: "100%",
                      height: "45vh",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "5px",
                      zIndex: 1,
                      height: "100%",
                    }}
                  />

                  {/* Main Card */}
                  <div
                    style={{
                      width: "99%",
                      height: "45vh",
                      backgroundColor: "#ffffff",
                      position: "relative",
                      borderRadius: "5px",
                      padding: "14px",
                      zIndex: 1,
                      height: "100%"
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "bold",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: "10px",
                      }}
                    >
                      <span>ROOM NAME</span>
                      <span>TOTAL</span>
                    </div>

                    {quotation.quotationData.map((item, i) => (
                      <div
                        key={i}
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "space-between",
                          marginTop: "10px",
                          fontSize: "15px",
                        }}
                      >
                        <span>{item.roomTypeName}</span>
                        <span style={{ fontWeight: "bold" }}>{item.roomTypePrice}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* RIGHT SIDE */}
                <div style={{ width: "50%", display: "flex", flexDirection: "column", gap: "10px" }}>
                  {/* GROSS TOTAL */}
                  <div style={{ position: "relative", width: "100%" }}>
                    {/* Shadow */}
                    <div
                      style={{
                        position: "absolute",
                        top: "4px",
                        width: "100%",
                        height: "23vh",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "5px",
                        zIndex: 1,
                        height: "100%",
                      }}
                    />
                    {/* Main Card */}
                    <div
                      style={{
                        width: "99%",
                        backgroundColor: "#ffffff",
                        padding: "10px",
                        borderRadius: "5px",
                        position: "relative",
                        zIndex: 2,
                      }}
                    >
                      <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
                        <span style={{ fontWeight: "bold" }}>GROSS TOTAL</span>
                      </div>

                      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
                        <span style={{ fontSize: "15px" }}>Total</span>
                        <span style={{ fontWeight: "bold", fontSize: "15px" }}>INR {quotation.quotationPrice}</span>
                      </div>

                      <hr style={{ border: "0.5px solid #f0f0f0", margin: "15px 0" }} />

                      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
                        <span style={{ fontSize: "15px" }}>Wood Work</span>
                        <span style={{ fontWeight: "bold", fontSize: "15px" }}>INR {quotation.quotationWood}</span>
                      </div>

                       <hr style={{ border: "0.5px solid #f0f0f0", margin: "15px 0" }} />

                      {quotation.quotationDiscount != 0 &&    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
                      <div>
                          <span style={{ fontSize: "15px" }}>Discount ({quotation.quotationDiscount}%)</span>
                          <br />
                          <small  style={{ fontSize: "10px" }}>Applied on woodwork only</small>
                        </div>
                      <span style={{ fontWeight: "bold", fontSize: "15px" }}>
                          INR {Math.round(quotation.quotationWood * (quotation.quotationDiscount / 100))}
                        </span>
                      </div>}

                      {quotation?.quotationSpecialDiscount && quotation?.quotationSpecialDiscount !== 0 &&    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
                      <div>
                          <span style={{ fontSize: "15px" }}>Special Discount (₹)</span>
                        </div>
                      <span style={{ fontWeight: "bold", fontSize: "15px" }}>
                          INR {quotation.quotationSpecialDiscount}
                        </span>
                      </div>}

                      <hr style={{ border: "0.5px solid #f0f0f0", margin: "15px 0" }} />

                      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
                        <span style={{ fontSize: "15px" }}>Discounted Final</span>
                        <span style={{ fontWeight: "bold", fontSize: "15px" }}>
                          INR{" "}
                          {Math.round(
                            quotation.quotationPrice - (quotation?.quotationSpecialDiscount || 0) - quotation.quotationWood * (quotation.quotationDiscount / 100)
                          )}
                        </span>
                      </div>

                      <hr style={{ border: "0.5px solid #f0f0f0", margin: "15px 0" }} />

                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <span style={{ fontSize: "15px" }}>GST</span>
                        <span style={{ fontWeight: "bold", fontSize: "15px" }}>
                          INR{" "}
                          {Math.round(
                           
                            ((quotation.quotationPrice - (quotation?.quotationSpecialDiscount || 0) -
                              quotation.quotationWood * (quotation.quotationDiscount / 100)) *
                              (quotation.quotationTaxation || 18)) /
                            100
                          )}
                        </span>
                      </div>


                      <hr style={{ border: "0.5px solid #f0f0f0", margin: "15px 0" }} />

                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <span style={{ fontSize: "15px" }}>Grand Total with GST</span>
                        <span style={{ fontWeight: "bold", fontSize: "15px" }}>
                          INR{" "}
                          {Math.round(
                            (quotation.quotationPrice -
                              (quotation?.quotationSpecialDiscount || 0) - quotation.quotationWood * (quotation.quotationDiscount / 100)) +
                            ((quotation.quotationPrice -
                              (quotation?.quotationSpecialDiscount || 0) - quotation.quotationWood * (quotation.quotationDiscount / 100)) *
                              (quotation.quotationTaxation || 18)) /
                            100
                          )}
                        </span>
                      </div>
                    </div>
                  </div>


                 {/* PAYMENT BREAKUP */}
                  <div style={{ position: "relative", width: "100%" }}>
                    {/* Shadow */}
                    {/* <div
                      style={{
                        position: "absolute",
                        top: "4px",
                        width: "100%",
                        height: "20vh",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "5px",
                        zIndex: 0,
                      }}
                    /> */}
                    {/* Main Card */}
                    {/* <div
                      style={{
                        position: "relative",
                        width: "99%",
                        backgroundColor: "#ffffff",
                        borderRadius: "5px",
                        padding: "10px",
                        zIndex: 1,
                      }}
                    >
                      <h4 style={{ textAlign: "center", marginBottom: "15px" }}>PAYMENT BREAKUP</h4>

                      {[
                        { label: "Commitment Advance", percent: 10 },
                        { label: "Production Advance", percent: 40 , gst:'GST as applied' },
                        { label: "Material Delivery", percent: 40 },
                        { label: "On Handover", percent: 10 },
                      ].map((pay, i) => (
                        <div
                          key={i}
                          style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}
                        >
                          <span>
                            {pay.label}
                          </span>
                          <span style={{ fontWeight: "bold" }}>
                           {pay.percent}% {pay.gst && <>+ {pay.gst}</>}

                          </span>
                        </div>
                      ))}
                    </div> */}
                  </div>
                </div>
              </div>
            </Col>
            <hr />


            <Row className='p-3'>
              <Col sm={12} className='border rounded p-2 bg-light-subtle'>
                <p style={{ color: '#e85d13', textAlign: 'center', fontSize: '1.5rem' }}>Rooms</p>
              </Col>
            </Row>
            <Row className='px-3' style={{ overflowX: 'auto' }}>

              <Col sm={12} className='border rounded p-2 bg-light-subtle'>
                <Accordion defaultActiveKey="0">

                  {quotation.quotationData.map((item, index) => (
                    <Accordion.Item eventKey={index}>
                      <Accordion.Header><b>{item.roomTypeName}</b></Accordion.Header>
                      <Accordion.Body >
                        <div className="table-container">
                          <div className="tableScroll">
                            <table responsive>
                              <thead>
                                <tr className="table-secondary">
                                  <th>Items / Description</th>
                                  <th>Finish</th>
                                  {
                                    quotation.quotationpermission ? (
                                      <>
                                        {quotation.quotationpermission?.width && <th>Width (FT)</th>}
                                        {quotation.quotationpermission?.height && <th>Height (FT)</th>}
                                        {quotation.quotationpermission?.area && <th>Area (Sqft / Rft)</th>}
                                      </>
                                    ) : (
                                      <>
                                        <th>Width (FT)</th>
                                        <th>Height (FT)</th>
                                        <th>Area <p>(Sqft / Rft)</p> </th>
                                      </>
                                    )
                                  }
                                  <th>Qty</th>
                                  {/* <th>Base Price</th> */}
                                  <th>Amount</th>
                                  <th>Remark</th>
                                </tr>
                              </thead>
                              <tbody>
                                {item.title.map((item2, index2) => (
                                  item2.value2 > 0 && item2.name == "Wardrobe - Slider" ?
                                    <tr key={index2}>
                                      <td>{item2.name}</td>
                                      <td>{item2.label}</td>

                                      {
                                        quotation.quotationpermission ? (
                                          <>
                                            {quotation.quotationpermission?.width && <td>{item2.width > 0 ? item2.width : null}</td>}
                                            {quotation.quotationpermission?.height && <td>{item2.height > 0 ? item2.height : null}</td>}
                                            {quotation.quotationpermission?.area &&

                                              <td>
                                                {
                                                  (() => {
                                                    let value;

                                                    if (item2.area > 0) {
                                                      value = item2.area;
                                                    } else if (item2.rft > 0) {
                                                      value = item2.rft;
                                                    } else if (item2.measurementType === "sqft" && item2.width > 0 && item2.height > 0) {
                                                      value = item2.width * item2.height;
                                                    } else if (item2.measurementType === "rft" && item2.width > 0) {
                                                      value = item2.width;
                                                    } 
                                                    else if (item2.width > 0 && item2.height > 0 && item2.depth > 0) {
                                                      value = (item2.width * item2.depth * 2) + ((item2.height - (item2.depth * 2)) * item2.depth * 2) + (((item2.width - (item2.depth * 2)) + (item2.height - (item2.depth * 2)) + (item2.width - (item2.depth * 2)) + (item2.height - (item2.depth * 2))) * 3);
                                                    } else if (item2.width > 0 && item2.height > 0) {
                                                      value = item2.width * item2.height;
                                                    } else {
                                                      value = null;
                                                    }

                                                    return value !== null ? Number(value.toFixed(2)) : null;
                                                  })()
                                                }
                                              </td>
                                            }
                                          </>
                                        ) : (
                                          <>
                                            <td>{item2.width > 0 ? item2.width : null}</td>
                                            <td>{item2.height > 0 ? item2.height : null}</td>
                                            <td>
                                              {
                                                (() => {
                                                  let value;

                                                  if (item2.area > 0) {
                                                    value = item2.area;
                                                  } else if (item2.rft > 0) {
                                                    value = item2.rft;
                                                  } else if (item2.measurementType === "sqft" && item2.width > 0 && item2.height > 0) {
                                                    value = item2.width * item2.height;
                                                  } else if (item2.measurementType === "rft" && item2.width > 0) {
                                                    value = item2.width;
                                                  }
                                                    else if (item2.width > 0 && item2.height > 0 && item2.depth > 0) {
                                                      value = (item2.width * item2.depth * 2) + ((item2.height - (item2.depth * 2)) * item2.depth * 2) + (((item2.width - (item2.depth * 2)) + (item2.height - (item2.depth * 2)) + (item2.width - (item2.depth * 2)) + (item2.height - (item2.depth * 2))) * 3);
                                                    } else if (item2.width > 0 && item2.height > 0) {
                                                      value = item2.width * item2.height;
                                                    } else {
                                                    value = null;
                                                  }

                                                  return value !== null ? Number(value.toFixed(2)) : null;
                                                })()
                                              }
                                            </td>
                                          </>
                                        )
                                      }


                                      <td>{item2.qnty > 0 ? item2.qnty : null}</td>

                                      {/* <td>{item2.price > 0 ? item2.valueIncresed : null}</td> */}
                                      <td>{item2.width !== '' || item2.height !== '' || item2.area !== '' && item2.price > 0 ? item2.price : null}</td>
                                      <td>{item2.remark}</td>
                                    </tr>
                                    : item2.label != '' &&  item2.name == "Shape Of Kitchen" ?
                                      <tr key={index2}>
                                        <td>{item2.name} </td>
                                        <td>{item2.label}</td>
                                        {
                                          quotation.quotationpermission ? (
                                            <>
                                              {quotation.quotationpermission?.width && <td>{item2.width > 0 ? item2.width : null}</td>}
                                              {quotation.quotationpermission?.height && <td>{item2.height > 0 ? item2.height : null}</td>}
                                              {quotation.quotationpermission?.area && <td>
                                                {
                                                  (() => {
                                                    let value;

                                                    if (item2.area > 0) {
                                                      value = item2.area;
                                                    } else if (item2.rft > 0) {
                                                      value = item2.rft;
                                                    } else if (item2.measurementType === "sqft" && item2.width > 0 && item2.height > 0) {
                                                      value = item2.width * item2.height;
                                                    } else if (item2.measurementType === "rft" && item2.width > 0) {
                                                      value = item2.width;
                                                    }
                                                    else if (item2.width > 0 && item2.height > 0 && item2.depth > 0) {
                                                      value = (item2.width * item2.depth * 2) + ((item2.height - (item2.depth * 2)) * item2.depth * 2) + (((item2.width - (item2.depth * 2)) + (item2.height - (item2.depth * 2)) + (item2.width - (item2.depth * 2)) + (item2.height - (item2.depth * 2))) * 3);
                                                    } else if (item2.width > 0 && item2.height > 0) {
                                                      value = item2.width * item2.height;
                                                    } else {
                                                      value = null;
                                                    }

                                                    return value !== null ? Number(value.toFixed(2)) : null;
                                                  })()
                                                }
                                              </td>}
                                            </>
                                          ) : (
                                            <>
                                              <td>{item2.width > 0 ? item2.width : null}</td>
                                              <td>{item2.height > 0 ? item2.height : null}</td>
                                              <td>
                                                {
                                                  (() => {
                                                    let value;

                                                    if (item2.area > 0) {
                                                      value = item2.area;
                                                    } else if (item2.rft > 0) {
                                                      value = item2.rft;
                                                    } else if (item2.measurementType === "sqft" && item2.width > 0 && item2.height > 0) {
                                                      value = item2.width * item2.height;
                                                    } else if (item2.measurementType === "rft" && item2.width > 0) {
                                                      value = item2.width;
                                                    }
                                                    else if (item2.width > 0 && item2.height > 0 && item2.depth > 0) {
                                                      value = (item2.width * item2.depth * 2) + ((item2.height - (item2.depth * 2)) * item2.depth * 2) + (((item2.width - (item2.depth * 2)) + (item2.height - (item2.depth * 2)) + (item2.width - (item2.depth * 2)) + (item2.height - (item2.depth * 2))) * 3);
                                                    } else if (item2.width > 0 && item2.height > 0) {
                                                      value = item2.width * item2.height;
                                                    } else {
                                                      value = null;
                                                    }

                                                    return value !== null ? Number(value.toFixed(2)) : null;
                                                  })()
                                                }
                                              </td>
                                            </>
                                          )
                                        }
                                        <td>{item2.qnty > 0 ? item2.qnty : null}</td>
                                        {/* <td>{item2.price > 0 ? item2.valueIncresed : null}</td> */}

                                        <td>{item2.price}</td>
                                        <td>{item2.remark}</td>
                                      </tr>
                                      : item2.price > 0 ?
                                        <tr key={index2}>
                                          <td>{item2.name} </td>
                                          <td>{item2.label}</td>
                                          {
                                            quotation.quotationpermission ? (
                                              <>
                                                {quotation.quotationpermission?.width && <td>{item2.width > 0 ? item2.width : null}</td>}
                                                {quotation.quotationpermission?.height && <td>{item2.height > 0 ? item2.height : null}</td>}
                                                {quotation.quotationpermission?.area && <td>
                                                  {
                                                    (() => {
                                                      let value;

                                                      if (item2.area > 0) {
                                                        value = item2.area;
                                                      } else if (item2.rft > 0) {
                                                        value = item2.rft;
                                                      } else if (item2.measurementType === "sqft" && item2.width > 0 && item2.height > 0) {
                                                        value = item2.width * item2.height;
                                                      } else if (item2.measurementType === "rft" && item2.width > 0) {
                                                        value = item2.width;
                                                      }
                                                    else if (item2.width > 0 && item2.height > 0 && item2.depth > 0) {
                                                      value = (item2.width * item2.depth * 2) + ((item2.height - (item2.depth * 2)) * item2.depth * 2) + (((item2.width - (item2.depth * 2)) + (item2.height - (item2.depth * 2)) + (item2.width - (item2.depth * 2)) + (item2.height - (item2.depth * 2))) * 3);
                                                    } else if (item2.width > 0 && item2.height > 0) {
                                                      value = item2.width * item2.height;
                                                    } else {
                                                        value = null;
                                                      }

                                                      return value !== null ? Number(value.toFixed(2)) : null;
                                                    })()
                                                  }
                                                </td>}
                                              </>
                                            ) : (
                                              <>
                                                <td>{item2.width > 0 ? item2.width : null}</td>
                                                <td>{item2.height > 0 ? item2.height : null}</td>
                                                <td>
                                                  {
                                                    (() => {
                                                      let value;

                                                      if (item2.area > 0) {
                                                        value = item2.area;
                                                      } else if (item2.rft > 0) {
                                                        value = item2.rft;
                                                      } else if (item2.measurementType === "sqft" && item2.width > 0 && item2.height > 0) {
                                                        value = item2.width * item2.height;
                                                      } else if (item2.measurementType === "rft" && item2.width > 0) {
                                                        value = item2.width;
                                                      }
                                                    else if (item2.width > 0 && item2.height > 0 && item2.depth > 0) {
                                                      value = (item2.width * item2.depth * 2) + ((item2.height - (item2.depth * 2)) * item2.depth * 2) + (((item2.width - (item2.depth * 2)) + (item2.height - (item2.depth * 2)) + (item2.width - (item2.depth * 2)) + (item2.height - (item2.depth * 2))) * 3);
                                                    } else if (item2.width > 0 && item2.height > 0) {
                                                      value = item2.width * item2.height;
                                                    } else {
                                                        value = null;
                                                      }

                                                      return value !== null ? Number(value.toFixed(2)) : null;
                                                    })()
                                                  }
                                                </td>
                                              </>
                                            )
                                          }
                                          <td>{item2.qnty > 0 ? item2.qnty : null}</td>
                                          {/* <td>{item2.price > 0 ? item2.valueIncresed : null}</td> */}

                                          <td>{item2.price}</td>
                                          <td>{item2.remark}</td>
                                        </tr>
                                        : item2.value > 0 && item2.isUserAdded ?
                                          <tr key={index2}>
                                            <td>{item2.name} </td>
                                            <td>{item2.label}</td>
                                            {
                                              quotation.quotationpermission ? (
                                                <>
                                                  {quotation.quotationpermission?.width && <td>{item2.width > 0 ? item2.width : null}</td>}
                                                  {quotation.quotationpermission?.height && <td>{item2.height > 0 ? item2.height : null}</td>}
                                                  {quotation.quotationpermission?.area && <td>
                                                    {
                                                      (() => {
                                                        let value;

                                                        if (item2.area > 0) {
                                                          value = item2.area;
                                                        } else if (item2.rft > 0) {
                                                          value = item2.rft;
                                                        } else if (item2.measurementType === "sqft" && item2.width > 0 && item2.height > 0) {
                                                          value = item2.width * item2.height;
                                                        } else if (item2.measurementType === "rft" && item2.width > 0) {
                                                          value = item2.width;
                                                        }
                                                    else if (item2.width > 0 && item2.height > 0 && item2.depth > 0) {
                                                      value = (item2.width * item2.depth * 2) + ((item2.height - (item2.depth * 2)) * item2.depth * 2) + (((item2.width - (item2.depth * 2)) + (item2.height - (item2.depth * 2)) + (item2.width - (item2.depth * 2)) + (item2.height - (item2.depth * 2))) * 3);
                                                    } else if (item2.width > 0 && item2.height > 0) {
                                                      value = item2.width * item2.height;
                                                    } else {
                                                          value = null;
                                                        }

                                                        return value !== null ? Number(value.toFixed(2)) : null;
                                                      })()
                                                    }
                                                  </td>}
                                                </>
                                              ) : 
                                              (
                                                <>
                                                  <td>{item2.width > 0 ? item2.width : null}</td>
                                                  <td>{item2.height > 0 ? item2.height : null}</td>
                                                  <td>
                                                    {
                                                      (() => {
                                                        let value;

                                                        if (item2.area > 0) {
                                                          value = item2.area;
                                                        } else if (item2.rft > 0) {
                                                          value = item2.rft;
                                                        } else if (item2.measurementType === "sqft" && item2.width > 0 && item2.height > 0) {
                                                          value = item2.width * item2.height;
                                                        } else if (item2.measurementType === "rft" && item2.width > 0) {
                                                          value = item2.width;
                                                        }
                                                    else if (item2.width > 0 && item2.height > 0 && item2.depth > 0) {
                                                      value = (item2.width * item2.depth * 2) + ((item2.height - (item2.depth * 2)) * item2.depth * 2) + (((item2.width - (item2.depth * 2)) + (item2.height - (item2.depth * 2)) + (item2.width - (item2.depth * 2)) + (item2.height - (item2.depth * 2))) * 3);
                                                    } else if (item2.width > 0 && item2.height > 0) {
                                                      value = item2.width * item2.height;
                                                    } else {
                                                          value = null;
                                                        }

                                                        return value !== null ? Number(value.toFixed(2)) : null;
                                                      })()
                                                    }
                                                  </td>
                                                </>
                                              )
                                            }
                                            <td>{item2.qnty > 0 ? item2.qnty : null}</td>
                                            {/* <td>{item2.price > 0 ? item2.valueIncresed : null}</td> */}
                                            <td>{item2.value > 0  ? item2.value : null}</td>
                                            <td>{item2.remark}</td>
                                          </tr>
                                          : item2.value > 0  ?
                                          <tr key={index2}>
                                            <td>{item2.name} </td>
                                            <td>{item2.label}</td>
                                            {
                                              quotation.quotationpermission ? (
                                                <>
                                                  {quotation.quotationpermission?.width && <td>{item2.width > 0 ? item2.width : null}</td>}
                                                  {quotation.quotationpermission?.height && <td>{item2.height > 0 ? item2.height : null}</td>}
                                                  {quotation.quotationpermission?.area && <td>
                                                    {
                                                      (() => {
                                                        let value;

                                                        if (item2.area > 0) {
                                                          value = item2.area;
                                                        } else if (item2.rft > 0) {
                                                          value = item2.rft;
                                                        } else if (item2.measurementType === "sqft" && item2.width > 0 && item2.height > 0) {
                                                          value = item2.width * item2.height;
                                                        } else if (item2.measurementType === "rft" && item2.width > 0) {
                                                          value = item2.width;
                                                        }
                                                    else if (item2.width > 0 && item2.height > 0 && item2.depth > 0) {
                                                      value = (item2.width * item2.depth * 2) + ((item2.height - (item2.depth * 2)) * item2.depth * 2) + (((item2.width - (item2.depth * 2)) + (item2.height - (item2.depth * 2)) + (item2.width - (item2.depth * 2)) + (item2.height - (item2.depth * 2))) * 3);
                                                    } else if (item2.width > 0 && item2.height > 0) {
                                                      value = item2.width * item2.height;
                                                    } else {
                                                          value = null;
                                                        }

                                                        return value !== null ? Number(value.toFixed(2)) : null;
                                                      })()
                                                    }
                                                  </td>}
                                                </>
                                              ) : 
                                              (
                                                <>
                                                  <td>{item2.width > 0 ? item2.width : null}</td>
                                                  <td>{item2.height > 0 ? item2.height : null}</td>
                                                  <td>
                                                    {
                                                      (() => {
                                                        let value;

                                                        if (item2.area > 0) {
                                                          value = item2.area;
                                                        } else if (item2.rft > 0) {
                                                          value = item2.rft;
                                                        } else if (item2.measurementType === "sqft" && item2.width > 0 && item2.height > 0) {
                                                          value = item2.width * item2.height;
                                                        } else if (item2.measurementType === "rft" && item2.width > 0) {
                                                          value = item2.width;
                                                        }
                                                    else if (item2.width > 0 && item2.height > 0 && item2.depth > 0) {
                                                      value = (item2.width * item2.depth * 2) + ((item2.height - (item2.depth * 2)) * item2.depth * 2) + (((item2.width - (item2.depth * 2)) + (item2.height - (item2.depth * 2)) + (item2.width - (item2.depth * 2)) + (item2.height - (item2.depth * 2))) * 3);
                                                    } else if (item2.width > 0 && item2.height > 0) {
                                                      value = item2.width * item2.height;
                                                    } else {
                                                          value = null;
                                                        }

                                                        return value !== null ? Number(value.toFixed(2)) : null;
                                                      })()
                                                    }
                                                  </td>
                                                </>
                                              )
                                            }
                                            <td>{item2.qnty > 0 ? item2.qnty : null}</td>
                                            {/* <td>{item2.price > 0 ? item2.valueIncresed : null}</td> */}

                                            <td>{item2.value > 0  ? item2.value : null}</td>
                                            <td>{item2.remark}</td>
                                          </tr>:null

                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>

                        {/* <Row className='bg-secondary-subtle border pt-2' style={{}}>
          <Col className='col-2'><p>Items / Description</p></Col>
          <Col className='col-2'><p>Finish</p></Col>
          <Col className='col-1 text-center'><p>Width (FT) </p></Col>
          <Col className='col-1 text-center'><p>Height (FT)</p></Col>
          <Col className='col-1 text-center'><p>Area (Sqft/RFT)</p></Col>
          <Col className='col-1 text-center'><p>Qty</p></Col>
          <Col className='col-1 '><p>Price</p></Col>
          <Col className='col-1 '><p>Amount </p></Col>
          <Col className='col-2 '><p>Remark</p></Col>
        </Row>
        {item.title.map((item2, index2) =>(
          item2.value2 > 0 || item2.name == "Wardrobe - Slider" ?
          <Row className='border-bottom pt-2'>
          <Col className='col-2'><p>{item2.name}</p></Col>
          <Col className='col-2'><p>{item2.label}</p></Col>
          <Col className='col-1 text-center'><p>{item2.width > 0 ? item2.width : null}</p></Col>
          <Col className='col-1 text-center'><p>{item2.height > 0 ? item2.height : null}</p></Col>
          <Col className='col-1 text-center'><p>{item2.area > 0 ? item2.area : null}</p></Col>
          <Col className='col-1 text-center'><p>{item2.qnty > 0 ? item2.qnty : null}</p></Col>
          <Col className='col-1 '><p>{item2.valueIncresed}</p></Col>
          <Col className='col-1 '><p>{item2.price > 0 ? item2.price : null}</p></Col>
          <Col className='col-2 '><p>{item2.remark}</p></Col>
        </Row>
          :  item2.price > 0 || item2.name == "Shape Of Kitchen" ?
          <Row className='border-bottom pt-2'>
          <Col className='col-2'><p>{item2.name}</p></Col>
          <Col className='col-2'><p>{item2.label}</p></Col>
          <Col className='col-1 text-center'><p>{item2.width > 0 ? item2.width : null}</p></Col>
          <Col className='col-1 text-center'><p>{item2.height > 0 ? item2.height : null}</p></Col>
          <Col className='col-1 text-center'><p>{item2.area > 0 ? item2.area : null}</p></Col>
          <Col className='col-1 text-center'><p>{item2.qnty > 0 ? item2.qnty : null}</p></Col>
          <Col className='col-1 '><p>1549 </p></Col>
          <Col className='col-1 '><p>{item2.value}</p></Col>
          <Col className='col-2 '><p>{item2.remark}</p></Col>
        </Row>
          :  item2.price > 0 ?
          <Row className='border-bottom pt-2'>
          <Col className='col-2'><p>{item2.name}</p></Col>
          <Col className='col-2'><p>{item2.label}</p></Col>
          <Col className='col-1 text-center'><p>{item2.width > 0 ? item2.width : null}</p></Col>
          <Col className='col-1 text-center'><p>{item2.height > 0 ? item2.height : null}</p></Col>
          <Col className='col-1 text-center'><p>{item2.area > 0 ? item2.area : null}</p></Col>
          <Col className='col-1 text-center'><p>{item2.qnty > 0 ? item2.qnty : null}</p></Col>
          <Col className='col-1 '><p>1549 </p></Col>
          <Col className='col-1 '><p>{item2.value}</p></Col>
          <Col className='col-2 '><p>{item2.remark}</p></Col>
        </Row>
          :  item2.value > 0 ? 
          <Row className='border-bottom pt-2'>
          <Col className='col-2'><p>{item2.name}</p></Col>
          <Col className='col-2'><p>{item2.label}</p></Col>
          <Col className='col-1 text-center'><p>{item2.width > 0 ? item2.width : null}</p></Col>
          <Col className='col-1 text-center'><p>{item2.height > 0 ? item2.height : null}</p></Col>
          <Col className='col-1 text-center'><p>{item2.area > 0 ? item2.area : null}</p></Col>
          <Col className='col-1 text-center'><p>{item2.qnty > 0 ? item2.qnty : null}</p></Col>
          <Col className='col-1 '><p>1549 </p></Col>
          <Col className='col-1 '><p>{item2.value}</p></Col>
          <Col className='col-2 '><p>{item2.remark}</p></Col>
        </Row>
          : null
        
        ))} */}

                      </Accordion.Body>
                    </Accordion.Item>
                  ))}



                </Accordion>
              </Col>
            </Row>



          </>



          <Row className='p-3'>
            <Col sm={12} className='border rounded p-2 bg-light-subtle'>
              <p style={{ color: '#e85d13', textAlign: 'center', fontSize: '1.5rem' }}>Material Specifications</p>
            </Col>
          </Row>

          <Row className='px-3'>
            <Col sm={12} md={12} className='border rounded p-4 bg-light-subtle '>



              <Row className='border-bottom pt-2'>
                <Col><p className='fw-semibold'>Laminate:</p>
                  <p>(Merino, Greenlam, Century, Realtouch, Heritage, Royal Touch). External Matt Laminated Finish 1.0 mm (Any Brand - SF, upto Rs.
                    1200 per sheet), unless otherwise specified. Internal Matt finish laminate of 0.79-0.8 mm, Hazel Cambric/off white color, unless and
                    otherwise specified.</p>
                </Col>
              </Row>

              <Row className='border-bottom pt-2'>
                <Col><p className='fw-semibold'>PLY:</p>
                  <p>We use Century Sainik Ply. Kitchen, Utility and Washroom
                - Below Boxes in BWP (Water Proof) Ply - 16 mm (Calibrated). Kitchen above boxes, wardrobe, other units, such
                as crockery/display/loft unit etc. in MR (Moisture Resistant) Ply - 16 mm (Calibrated).</p>
                </Col>
              </Row>

              <Row className='border-bottom pt-2'>
                <Col><p className='fw-semibold'>Hardware:</p>
                  <p>Hafele/Hettich/EBCO Hinges and other hardware (Tandem Box, Channels, Sliders etc) shall be of regular operations (Soft Close on
                    Demand). Handles, Knobs, shall be of local supply (with basic rate of Rs. 100/pc 8 inch and Rs, 50/Pc 4 inch) or as per selection .
                    Wire-Baskets (Plate, thali, cutlery or bottle pullout) if any, shall be stainless steel (Local Supply) grade-304. Wicker Basket if any, will
                    be local supply as per IS standards and size customizable. Kitchen Skirting shall be a PVC make of approved color and finish with
                    PVC adjustable legs. 5mm plain glass for glass shutters, unless otherwise specified with wooden frame. (Aluminium shutters can be
                    on demand). 6mm plain glass for Shelves ad per drawings or unless otherwise specified.</p>
                </Col>
              </Row>

              <Row className='border-bottom pt-2'>
                <Col><p className='fw-semibold'>Others:</p>
                  <p>SS Shelf pins, Clamps, Screw and other fixtures - local supply. Dowels & Mini-fix - Hettich. Glue - Pedilite (Adhesive), Araldite, Jotun,
                    Rehau, woodmaster or equivelent based on application. Edge Banding - Rehau or Equivalent (1mm or 2mm as per application).</p>
                </Col>
              </Row>

              <Row className='pt-2'>
                <Col><p className='fw-semibold'>Paint, Polish & Powdercoat:</p>
                  <p>As per selection (Asian, Dulux, Berger, RAL), only if mentioned in quote.</p>
                </Col>
              </Row>


            </Col>

          </Row>


          <Row className='p-3'>
            <Col sm={12} className='border rounded p-2 bg-light-subtle'>
              <p style={{ color: '#e85d13', textAlign: 'center', fontSize: '1.5rem' }}>Terms & Conditions</p>

            </Col>
          </Row>

          <Row className='px-3 pb-3'>
            <Col sm={12} md={12} className='border rounded p-4 bg-light-subtle '>



              <Row className='border-bottom pt-2'>
                <Col><p className='fw-semibold'>Warranty :</p>
                  <ol>
                    <li> We provide 10 years warranty for plywood, This safeguards you against any defect in manufacturing or in installation workmanship
                      under normal usage. Hardware warranty will be apllicable based on the brands chosen For custom work, there is no warranty applicable.
                      For more information about warranty policy we suggest you to ask FABDIZ warranty policy to our Design consultant. <br />  <b> Note: </b>1 year of free servicing for our product</li>

                    <li>All accessories, hardware and appliances are covered as per the respective Manufacturers.</li>
                  </ol>
                </Col>
              </Row>

              <Row className='border-bottom pt-2'>
                <Col><p className='fw-semibold'>General terms :</p>
                  <ol>
                    <li>Chimney, Sink, Hob, Gas Piping, Granite along with the labour cost associated are not included in this quotation unless mentioned
                      otherwise.
                    </li>
                    <li> Light Fittings, Geyser, Bathroom Fittings, Fans and any other electrical fittings are not included in this quotation unless mentioned
                      otherwise.
                    </li>
                    <li>Any product that is not added in this Quotation has to be assumed as Non Tendered Product, a revised quote will be provided for the
                      same. FABDIZ will only be responsible for work mentioned in the quotation.</li>
                    <li>Alteration of the existing electrical wiring/points and plumbing wiring/points will be charged extra and for any civil changes like plumbing
                      and wall chipping we need civil engineers for instructions.</li>
                    <li>FABDIZ execution team takes the responsibility of moving debris to Garbage Room of the apartment premises</li>
                    <li>FABDIZ execution team takes the responsibility of cleaning floor & interiors before moving out of the site (Deep cleaning not included).</li>
                    <li>Sliding Door Track fitting will bring 15-25mm gap between the Sliding Door and loft. As we need that gap during the maintenance. Sliding
                      Door Track fitting will bring 10mm gap between the door overlapping.
                    </li>
                    <li>Product with glossy finish may have very less unevenness look and feel due to lighting effect</li>
                    <li>This quotation will be valid for 1 month.</li>

                    <li>Final coat of paint should be done after completion of interior work from client side We are unable to avoid handmarks, scratches during
                      installation.</li>
                    <li>There will be difference between in handmade furniture and modular furniture. As handmade furniture by carpenters on site with hand
                      tools so as compared to modular work handmade furniture finishing will differ.
                    </li>
                    <li>Images shown in the 3d are for reference, please refer actual samples for colour selection and texture / wallpapers or any decor items
                      which might be shown only for reference.</li>
                    <li>Design alterations will not be considered once the design document is signed off or once FADBIZ get confirmation for design document
                      through mail/electronic media
                    </li>
                    <li>Production date will start as per the schedule that will be shared.</li>
                    <li>Any modifications at site should be informed to the designer and project manager prior to production.</li>
                    <li>FABDIZ will not be responsible for products purchased from elsewhere.</li>

                    <li>The Entertainment Cabinet and other modular cabinets more than 2400MM will be having two cabinets in that case the joint at the top
                      of the cabinet will be visible.</li>
                  </ol>
                </Col>
              </Row>

              <Row className='border-bottom pt-2'>
                <Col><p className='fw-semibold'>Design Process :</p>
                  <ol>
                    <li><strong>Site Visit :</strong> Once booking advance paid Interior Designer will visit the client site with measurement team.</li>
                    <li><strong>Discussion Meeting:</strong> Designer will show the modular library, completed project photographs which will match to client requirement.</li>
                    <li><strong>Modeling Presentation:</strong> As per client requirement and placement of furniture designer will present modeling. (upto 2 iteration can be
                      done in the 3d model stage post that timelines may change as per additional design changes.</li>
                    <li><strong>3D Design Presentation:</strong> will present 3D design which will have the texture selected by client.</li>
                    <li><strong>Site Validation:</strong> Validation will be done at site where FABDIZ will execute project. Designer will visit the site with Project Manager for
                      Masking Measurement. Masking measurement will be possible only on cleaned floor.</li>

                  </ol>
                </Col>
              </Row>

                         <Row className="border-bottom pt-3 pb-3">
             <Col>
               <p className='fw-semibold'>3. Payment Terms</p>
           
               <p className="mb-4">
                 Payments shall be made in accordance with the following schedule:
               </p>
           
               <table
                 className="w-100 text-center"
                 style={{
                   borderCollapse: "collapse",
                   border: "1px solid #2b2a2a",
                 }}
               >
                 <thead>
                   <tr>
                     <th
                       style={{
                         border: "1px solid #1b1b1b",
                         padding: "12px",
                         fontSize: "18px",
                         fontWeight: "700",
                         width: "20%",
                         color:'black'
                       }}
                     >
                       Stage
                     </th>
           
                     <th
                       style={{
                         border: "1px solid #1b1b1b",
                         padding: "12px",
                         fontSize: "18px",
                         fontWeight: "700",
                         width: "18%",
                         color:'black'
                       }}
                     >
                       Payment %
                     </th>
           
                     <th
                       style={{
                         border: "1px solid #1b1b1b",
                         padding: "12px",
                         fontSize: "18px",
                         fontWeight: "700",
                         color:'black'
                       }}
                     >
                       Details
                     </th>
                   </tr>
                 </thead>
           
                 <tbody>
                   <tr>
                     <td style={tdStyle}>Booking Amount</td>
                     <td style={tdStyle}>10%</td>
                     <td style={{ border: "1px solid #3f3d3d",padding: "14px",fontSize: "14px",textAlign:'left' ,color:'black'}}>
                       Upon confirmation of project
                     </td>
                   </tr>
           
                   <tr>
                     <td style={tdStyle}>Milestone 1</td>
                     <td style={tdStyle}>20%</td>
                     <td style={{ border: "1px solid #3f3d3d",padding: "14px",fontSize: "14px",textAlign:'left' ,color:'black'}}>
                       Upon material selection and approval of design quotation
                     </td>
                   </tr>
           
                   <tr>
                     <td style={tdStyle}>Milestone 2</td>
                     <td style={tdStyle}>20%</td>
                     <td style={{ border: "1px solid #3f3d3d",padding: "14px",fontSize: "14px",textAlign:'left' ,color:'black'}}>
                       Upon site validation and prior to issuance of sign-off
                       documents
                     </td>
                   </tr>
           
                   <tr>
                     <td style={tdStyle}>Milestone 3</td>
                     <td style={tdStyle}>100%</td>
                     <td style={{ border: "1px solid #3f3d3d",padding: "14px",fontSize: "14px",textAlign:'left' ,color:'black'}}>
                       As per quotation provided by the Project Manager
                       (Civil/Electrical/Plumbing/Painting)
                     </td>
                   </tr>
           
                   <tr>
                     <td style={tdStyle}>Milestone 4</td>
                     <td style={tdStyle}>40%</td>
                     <td style={{ border: "1px solid #3f3d3d",padding: "14px",fontSize: "14px",textAlign:'left' ,color:'black'}}>
                       Prior to dispatch of materials from factory
                     </td>
                   </tr>
           
                   <tr>
                     <td style={tdStyle}>Milestone 5</td>
                     <td style={tdStyle}>10%</td>
                     <td style={{ border: "1px solid #3f3d3d",padding: "14px",fontSize: "14px",textAlign:'left' ,color:'black'}}>
                       Upon carcass installation and quality check
                     </td>
                   </tr>
                 </tbody>
               </table>
           
               <p className="mt-3 mb-0">
                 GST 18% shall be charged additionally and shall be payable along
                 with each milestone payment.
               </p>
             </Col>
           </Row>




            </Col>

          </Row>



          {/* <PDFDownloadLink
        document={<ClientPDF e={quotation} />}
        fileName={'Invoice.pdf'}
        className="btn btn-primary">
        {({ blob, url, loading, error }) =>
          loading ? "Loading..." : "Download PDF"
        }
      </PDFDownloadLink> */}


          <Link to="/ClientPDFview" state={{ quotation, userDetails1 }}>
            <Button>Download PDF</Button>
          </Link>



        </Col>
      </Row>




    </Container>


  )
}
